import styled from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

// Styles Trade-in information

export const Actions = styled.div`
    margin-top: ${theme.space[3]}px;
`;

export const Wrapper = styled.div`
    margin: ${theme.space[3]}px 0 0;

    & + ${Actions} {
        margin-top: ${theme.space[1]}px;
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${theme.space[1]}px;
`;

export const Body = styled.div`
    display: flex;
    justify-content: space-between;
    font-family: ${theme.fonts.book};
    font-size: 1.4rem;
    line-height: 2rem;
`;

export const Title = styled.h2`
    margin: 0;
    font-family: ${theme.fonts.regular};
    font-size: 1.4rem;
    letter-spacing: 0.1rem;
    line-height: 2rem;
`;

export const TradeInValue = styled.div`
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    letter-spacing: 0.1rem;
    line-height: 2rem;
`;

// Styles Trade-in notification

export const TradeInNotificationWrapper = styled.div<{ show?: boolean }>`
    position: relative;
    margin-top: ${({ show }) => (show ? theme.space[3] : 0)}px;
`;

export const TradeInNotificationModal = styled.div<{ show?: boolean }>`
    position: absolute;
    width: 100%;
    margin-top: -15px;
    padding: ${theme.space[3]}px;
    background-color: ${theme.colors.silver};
    transition: opacity 0.3s;
    opacity: ${({ show }) => (show ? 1 : 0)};
    z-index: 1;
    pointer-events: ${({ show }) => (show ? "auto" : "none")};
`;

export const TradeInNotificationHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${theme.space[2]}px;
`;

export const TradeInNotificationBody = styled.div`
    font-family: ${theme.fonts.book};
    font-size: 1.4rem;
    line-height: 2rem;
`;

export const TradeInNotificationTitle = styled.h2`
    margin: 0;
    font-family: ${theme.fonts.regular};
    font-size: 1.4rem;
    letter-spacing: 0.1rem;
    line-height: 2rem;
`;
